import React, { useMemo } from 'react';
import Swatches from '@/features/pdp/components/ProductSwatches/Swatches';

const BundleSwatches = ({ options, itemHandler, label }) => {
  const swatchChangeHandler = (swatch) => () => {
    const originalSwatch = options.find((o) => o.id === swatch.id);

    itemHandler(originalSwatch)();
  };

  const mappedOptions = useMemo(
    () =>
      options
        .map((option) => ({
          id: option.id,
          key: label,
          value: option.label,
          sortOrder: option.sortOrder,
          isInStock: true,
          isDirectChoice: true,
          startColorCode: option.startColorCode,
          endColorCode: option.endColorCode,
          swatchImageUrl: option.swatchImageUrl,
          url: option.url,
          isAvailable: true,
          isColorLight: false,
          isColorDark: true,
          formattedValue: option.label,
          rate: 0,
          minAdditionalSalePercent: 0,
          maxAdditionalSalePercent: 0,
          isLimitedEdition: false,
          isClearance: false,
          canCustomize: false,
          canMiyo: false,
          isSelected: option.isSelected,
        }))
        .sort((a, b) => a.sortOrder - b.sortOrder),
    [options]
  );

  const activeOption = useMemo(() => mappedOptions.find((option) => option.isSelected), [mappedOptions]);

  if (mappedOptions.length <= 1) return null;

  return (
    <Swatches
      label='Size'
      swatchSize='sm'
      attributes={mappedOptions}
      activeAttribute={activeOption}
      itemHandler={swatchChangeHandler}
      wrapperClassName='tw-w-full tw-mt-1 tw-mb-3'
    />
  );
};

export default BundleSwatches;
